"use client";

import { useEffect, useRef, useState, type ReactNode } from "react";
import { loadFeedPageAction } from "./load-feed-page-action";

/** The rows loaded so far, whether there are none left, and the element to put at the end of the list: each time it comes into view the next page is fetched. */
export function useFeedPages(locale: string, search: Record<string, string>, firstPage: number) {
  const [batches, setBatches] = useState<ReactNode[]>([]);
  const [done, setDone] = useState(false);
  const page = useRef(firstPage);
  const busy = useRef(false);
  const end = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (done || !end.current) return;
    const watcher = new IntersectionObserver(async ([seen]) => {
      if (!seen.isIntersecting || busy.current) return;
      busy.current = true;
      const next = await loadFeedPageAction(locale, search, page.current).catch(() => ({ rows: null, done: true }));
      page.current += 1;
      setBatches((all) => [...all, next.rows]);
      setDone(next.done);
      busy.current = false;
    }, { rootMargin: "400px" });
    watcher.observe(end.current);
    return () => watcher.disconnect();
  }, [done, locale, search]);
  return { batches, done, end };
}
